import FlexPane from './_flex-pane.js'
import SkeletonPart from './_skeleton-part.js'

export default {
  name: 'RaceCouponsSkeleton',
  values: {
    numberOfStartTimes: 16,
    _mobile_numberOfStartTimes: 12,
    maxButtonsInRow: 8,
    _mobile_maxButtonsInRow: 4,
    topLevelContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          _mobile_padding: '0px 8px',
          flexDirection: 'column',
        },
      },
    },
    container: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '12px',
        separator: {
          style: {
            size: '1px',
          },
        },
        style: {
          height: '100%',
          padding: '8px',
          flexDirection: 'column',
        },
      },
    },
    headerContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '16px',
        style: {
          flexGrow: 0,
          flexDirection: 'column',
        },
      },
    },
    iconAndRegionContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          flexDirection: 'row',
        },
      },
    },
    icon: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          height: '16px',
          width: '16px',
        },
      },
    },
    region: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          height: '16px',
          width: '120px',
        },
      },
    },
    filterContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          flexDirection: 'row',
        },
      },
    },
    filter: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          height: '40px',
          width: '88px',
        },
      },
    },
    startTimeAndMeetingsContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '16px',
        style: {
          flexGrow: 0,
          flexDirection: 'column',
        },
      },
    },
    startTimesContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          flexGrow: 0,
          flexDirection: 'column',
        },
      },
    },
    meetingsContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          justifyContent: 'space-between',
          flexDirection: 'row',
        },
      },
    },
    meetingName: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          height: '14px',
          width: '103px',
        },
      },
    },
    trackStatus: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          height: '13px',
          width: '70px',
        },
      },
    },
    startTimeContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          flexDirection: 'row',
        },
      },
    },
    startTime: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          height: '40px',
          width: '106px',
          _mobile_width: '85px',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
